$(function () {
    var target = $('#autoVideo');

    function pause_play() {
        if (target.length) {
            var video = document.querySelector('.local-video video');
            var playPauseButton = document.querySelector('.playpause');
            var playPauseButtonText = document.querySelector('#local-video-controls-button-text');

            if (playPauseButton) {
                playPauseButton.classList.add('__play');

                // Play/Pause button
                playPauseButton.onclick = function () {
                    if (video.paused) {
                        // is paused, click to play
                        video.play();
                        playPauseButton.classList.remove('__play');
                        playPauseButton.classList.add('__pause');
                        playPauseButtonText.textContent = 'Pause';
                    } else {
                        // is playing, click to pause
                        video.pause();
                        playPauseButton.classList.add('__play');
                        playPauseButton.classList.remove('__pause');
                        playPauseButtonText.textContent = 'Play';
                    }
                };
            }
        }
    }

    function sound_mute() {
        if (target.length) {
            var video = document.querySelector('.local-video video');
            var soundMuteButton = document.querySelector('.soundmute');
            var soundMuteButtonText = document.querySelector('#local-video-controls-button-sound');
            function toggleMute() {
                video.muted = !video.muted;
            }

            if (soundMuteButton) {
                // Play/Pause button
                soundMuteButton.onclick = function () {
                    toggleMute();
                    if (video.muted) {
                        // is muted, click to play sound
                        video.removeAttribute('muted');
                        soundMuteButton.classList.remove('__sound');
                        soundMuteButton.classList.add('__mute');
                        soundMuteButtonText.textContent = 'Mute';
                    } else {
                        // is playing, click to pause
                        video.setAttribute('muted', '');
                        soundMuteButton.classList.add('__sound');
                        soundMuteButton.classList.remove('__mute');
                        soundMuteButtonText.textContent = 'Sound';
                    }
                };
            }
        }
    }

    pause_play();
    sound_mute();
});
